<div class="row">
	<div class="col-sm-12">
		{{#if actions}}
		<div class="btn-group pull-right">
			{{#each actions}}
			{{#if show_me}}
				{{#if menu_items}}
					{{!-- show menu entries --}}
					<div class="btn-group">
						<button id="js-action-menu" class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown">
							<i class="{{icon}}"></i>&nbsp;<span class="caret"></span>
						</button>
						<ul class="dropdown-menu dropdown-menu-right">
							{{#each menu_items}}
							<li>
								<a href={{#if href}}"{{href}}" target="_blank"{{else}}"#" class="js-action"{{/if}} id="js-action{{idx}}">
									{{#if icon}}<i class="{{icon}} m-r-5" {{#if color}}style="color:{{color}};"{{/if}}></i>{{/if}} {{name}}
								</a>
							</li>
							{{/each}}
						</ul>
					</div>
				{{else}}
					{{!-- show single action button --}}
					<a id="js-action{{idx}}" class="btn btn-default js-action" {{#if name}}data-action="{{name}}"{{/if}}>
						{{#if action_label}}
							{{{action_label}}}
						{{else}}
							<i class="{{icon}}"></i>
						{{/if}}
					</a>
				{{/if}}
			{{/if}}
			{{/each}}
		</div>
		{{/if}}
		<ol class="breadcrumb p-0">
			<li>
				<a href="#"><i class="fa fa-home"></i></a>
			</li>
			{{#if parentLink}}
				<li>
					<a href="{{parentLink}}"><i class="fa {{parentIcon}}"></i></a>
				</li>
			{{/if}}
			<li>
				<a href="{{base.link}}">{{base.title}}</a>
			</li>
			{{#if noSiblings}}
				<li><a href="{{base.link}}/{{device.id}}">{{#if icon}}<i class="fa {{icon.icon}}" title="{{icon.title}}"></i> {{/if}}{{device.attributes.name}} {{#if locked}}<i class="fa fa-lock"></i>{{/if}}</a>
				</li>
			{{else}}
				<li id="js-siblings-dropdown">
					{{#DEVICE_SELECT device.id 'breadcrumb-dropdown'}}
					<select id="device-{{index}}" class="js-input js-device">
					</select>
					{{/DEVICE_SELECT}}

				</li>
			{{/if}}

			<li>{{target.title}}</li>
		</ol>
	</div>
</div>
